// removed by extract-text-webpack-plugin
module.exports = {"students-cell":"StudentsCell__students-cell___2ape3","image":"StudentsCell__image___1xsEa","name-container":"StudentsCell__name-container___21LnX"};